module.exports = __webpack_public_path__ + "img/product_81.20f4d86.webp";